import dayjs from "dayjs";

export const handleRescheduleWorkOrder = (
  rows,
  days,
  putRescheduleWorkOrder,
  { dateIndex, idx, workOrder }
) => {
  const newStartDate = days[dateIndex] || days[0];

  const highIdx = rows.findIndex(
    (wo) => dayjs(wo.routingStart) > dayjs(newStartDate.id)
  );
  const newIdx = highIdx < 0 ? rows.length : highIdx > 0 ? highIdx - 1 : 0;

  if (idx === newIdx) return;

  const gantts = Array.from(document.querySelectorAll(".gantt-workOrder"));
  const isStart = newIdx < idx;
  const range = isStart ? [newIdx, idx] : [idx - 1, newIdx];
  const dir = isStart ? -35 : 35;

  requestAnimationFrame(() => {
    gantts.forEach((gantt, itr) => {
      if (itr <= range[0] || itr > range[1]) return;
      const moveItr = Math.abs(idx - newIdx) - (isStart ? 1 : 0);
      const translate = itr == idx ? moveItr * dir : -dir;
      gantt.style.transition = "transform 0.25s ease-in-out";
      gantt.style.transform = `translateY(${translate}px)`;
    });
  });

  // Fire request right away
  const startDate = dayjs(newStartDate.id).utc().toISOString();
  const payload = { id: workOrder, startDate };
  putRescheduleWorkOrder(payload);
};
